import { useState } from 'react';
import { IBaseCellsProps } from '../cells.interfaces';
import { StyledMenu, StyledTableCell } from './CellMenu.styles';
import { Icon, IconButton, MenuItem, useTheme } from '../../../base-components';
import { Directions } from '../../../../common';

interface Props extends IBaseCellsProps {
    isHeaderCell?: boolean;
    disabled?: boolean;
    data: {
        menuActions: Array<{
            label: string;
            action: string;
            disabled: boolean;
        }>;
    };
    onMenuItemClick: (
        cellId: string | undefined,
        item: Record<string, string> | undefined,
        actionId: string
    ) => void;
}

const CellMenu = (props: Props) => {
    const {
        alignment,
        columnIndex,
        isRowSelected,
        stickyColumn,
        rowStickyWidths,
        isHeaderCell = false,
        disabled = false,
        data = { menuActions: [] },
        onMenuItemClick,
        rowData,
    } = props;
    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const handleMenuItemClick = (
        event: React.MouseEvent<HTMLElement>,
        action: string
    ) => {
        event.stopPropagation();
        onMenuItemClick(rowData?.data?.id, rowData?.data, action);
        handleClose(event);
    };

    return (
        <StyledTableCell
            alignment={alignment}
            columnIndex={columnIndex}
            isSelected={isRowSelected}
            rowStickyWidths={rowStickyWidths}
            stickyColumn={stickyColumn}
            isHeaderCell={isHeaderCell}
            onClick={(e) => e.stopPropagation()}
        >
            <IconButton
                disabled={disabled}
                onClick={handleClick}
                sx={{ height: 24, width: 24 }}
            >
                <Icon name={'MoreVertIcon'} />
            </IconButton>
            <StyledMenu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={(e) => e.stopPropagation()}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal:
                        theme.direction == Directions.rtl ? 'right' : 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal:
                        theme.direction == Directions.rtl ? 'left' : 'right',
                }}
            >
                {data?.menuActions?.map((actionItem) => (
                    <MenuItem
                        key={actionItem.action}
                        disabled={actionItem.disabled}
                        onClick={(e) =>
                            handleMenuItemClick(e, actionItem.action)
                        }
                    >
                        {actionItem.label}
                    </MenuItem>
                ))}
            </StyledMenu>
        </StyledTableCell>
    );
};

export default CellMenu;
